import * as React from 'react';
import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface ErrorStateProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  description?: string;
  /** Optional retry control (e.g. a Button) rendered under the copy. */
  action?: React.ReactNode;
}

/**
 * Clay error state in the destructive tone. Used wherever a query/mutation
 * fails, so failure looks intentional rather than broken.
 */
export function ErrorState({
  title = "Something went wrong",
  description = 'Please try again.',
  action,
  className,
  ...props
}: ErrorStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center gap-3 rounded-card border-2 border-destructive/25 bg-destructive/5 px-6 py-10 text-center shadow-clay-sm',
        className,
      )}
      {...props}
    >
      <div className="flex h-12 w-12 items-center justify-center rounded-button bg-destructive/12 text-destructive shadow-clay-sm">
        <AlertTriangle className="h-6 w-6" />
      </div>
      <p className="font-heading text-base font-bold text-foreground">{title}</p>
      {description && <p className="max-w-sm text-sm text-muted-foreground">{description}</p>}
      {action && <div className="mt-1">{action}</div>}
    </div>
  );
}
